export enum TeamReviewMemberOrderSetting {
    Any = 0,
    Sequential = 1
}